export default __webpack_public_path__ + "static/media/Instagram.f2995449.png";